import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter'
})
export class SearchFilterPipe implements PipeTransform {

  transform(value: any, search: string): any {
    if (!search) { return value; }
    let solution = value.filter(v => {
      if (!v) { return; }
      return v.toLowerCase().indexOf(search.toLowerCase()) !== -1;
    })
    return solution;
  }

}
@Pipe({
  name: 'daysAgo'
})
export class DaysAgoPipe implements PipeTransform {
  transform(value: string): string {
    const parsedDate = new Date(value.replace(' ', 'T'));
    const now = new Date();
    const diffTime = now.getTime() - parsedDate.getTime();
    const days = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return `${days} days ago`;
  }
}

@Pipe({
  name: 'daysHoursAgo',
})
export class DaysHoursAgoPipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '';

    // Handle string conversion or Date objects
    const parsedDate = typeof value === 'string'
      ? new Date(value.replace(' ', 'T'))
      : new Date(value);

    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - parsedDate.getTime()) / 1000);

    // If the date is in the future
    if (diffInSeconds < 0) return 'just now';

    // Time calculations
    const minutes = Math.floor(diffInSeconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    // Logic for returning the most relevant string
    if (days > 0) {
      return days === 1 ? '1 day ago' : `${days} days ago`;
    } else if (hours > 0) {
      return hours === 1 ? '1 hr ago' : `${hours} hr ago`;
    } else if (minutes > 0) {
      return minutes === 1 ? '1 min ago' : `${minutes} min ago`;
    } else {
      return 'just now';
    }
  }
}

@Pipe({
  name: 'stripHtml'
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string, ...args: any[]): string {
    if (!value) return '';

    // Check pipe arguments for different stripping options
    const option = args[0] || 'all';

    switch (option) {
      case 'all':
        // Strip ALL HTML tags
        return value.replace(/<[^>]*>/g, '');

      case 'emptyParagraphs':
        // Remove only empty paragraphs
        return value.replace(/<p>\s*<\/p>/g, '');

      case 'specific':
        // Remove specific tags (div, span)
        return value
          .replace(/<div[^>]*>/g, '')
          .replace(/<\/div>/g, '')
          .replace(/<span[^>]*>/g, '')
          .replace(/<\/span>/g, '');

      case 'keepFormatting':
        // Keep basic formatting, remove others
        return value
          .replace(/<(?!\/?(p|br|b|i|strong|em))[^>]*>/g, '');

      default:
        return value.replace(/<[^>]*>/g, '');
    }
  }
}